if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;
        this.handleErrorMessage();
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );
        let lastResponse; 
        const config = fetchConfig("json");
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        const jsonBody = Object.fromEntries(formData.entries());

        //handle properties
        const properties = {};
        const propRE = /properties\[(.*)\]/gm;
        for(let key in jsonBody){
          propRE.lastIndex = 0;
          const match = propRE.exec(key);
          if(match){
            properties[match[1]] = jsonBody[key];  
            delete jsonBody[key];
          }
        }
        if(Object.keys(properties).length != 0){
          jsonBody['properties'] = properties;
        }


        config.body = JSON.stringify(jsonBody);
        try {
          const response = await fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())

            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            lastResponse = response;

            // Warranty add to cart

            const warrantyId = parseInt(
              document.querySelector('input[name="warranty"]:checked')?.value
            );

            if (warrantyId) {
              const warrantyQuantity = parseInt(Object.fromEntries(formData).quantity);
              const warrantyForProductId = parseInt(Object.fromEntries(formData).id);
              const warrantyForProductName = document.getElementById("product__title")?.innerText;
              const item = {
                id: warrantyId,
                quantity: warrantyQuantity,
                properties: {
                  "Warranty for": warrantyForProductName,
                  "_warranty_for_product_id": warrantyForProductId
                },
                sections: this.cart.getSectionsToRender().map((section) => section.id),
                sections_url: window.location.pathname
              };
              const warrantyConfig = fetchConfig("json");
              warrantyConfig.body = JSON.stringify(item);
    
              const response = await fetch(`${routes.cart_add_url}`, warrantyConfig)
              .then((response) => response.json())
              lastResponse = response;
            }

            // BOGO add to cart

            const bogoId = parseInt(
              document.querySelector('input[name="bogo"]:checked')?.value
            );

            if (bogoId) {
              const bogoQuantity = parseInt(
                document.querySelector('input[name="bogo"]:checked')?.dataset.quantity
              );
              const bogoForQuantity = parseInt(Object.fromEntries(formData).quantity);
              const bogoCartQuantity = bogoForQuantity * bogoQuantity;
              const bogoForProductId = parseInt(Object.fromEntries(formData).id);
              const item = {
                  id: bogoId,
                  quantity: bogoCartQuantity,
                  properties: {
                    "BOGO for": "Free Gift",
                    "_bogo_for_product_id": bogoForProductId,
                    "_bogo_quantity": bogoQuantity
                  },
                  sections: this.cart.getSectionsToRender().map((section) => section.id),
                  sections_url: window.location.pathname
              };  
              const bogoConfig = fetchConfig("json");
              bogoConfig.body = JSON.stringify(item);
    
              const response = await fetch(`${routes.cart_add_url}`, bogoConfig)
              .then((response) => response.json())
              lastResponse = response;
            }

            if (lastResponse) {
              const quickAddModal = this.closest("quick-add-modal");
              if (quickAddModal) {
                document.body.addEventListener(
                  "modalClosed",
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(lastResponse);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(lastResponse);
              }

              window.searchspringTracking?.scheduleCartViewSync?.();
            }

            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );

        } catch {
          (e) => {
            console.error(e);
          };
        }
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
